/**
 * @public
 */
export enum WebsocketKind {
  Response = 'response',
  Request = 'request',
}
